// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductsList_root__18zzr","next-matches":"ProductsList_next-matches__3inAe","products":"ProductsList_products__1uvRT"};